/**
 * Where the page points. One file, because these are the strings most likely to
 * be wrong in three places at once.
 *
 * **The repository, the docs tree and the decision log used to be here and are
 * gone.** Kimene is not an open-source project, and a public page whose header
 * offered "Belgeler · Kararlar · Depo" was inviting every reader into the source
 * tree. Nothing on this site may link there again — `i18n/voice.test.ts` reads
 * the whole of `src/` and fails on any of the common repository hosts by name,
 * which is why none of them is written out here.
 */
export const CONSOLE_URL = 'https://app.kimene.tr/'
export const SITE_ORIGIN = 'https://kimene.tr'

/**
 * Who makes it.
 *
 * Kept as data rather than as copy because an address is not a translation: the
 * street does not change language, and a catalogue entry per locale is two
 * places for a telephone number to be wrong. Only the labels around these are
 * translated.
 */
export const COMPANY = {
  legalName: 'Arpanet Bilişim Teknolojileri A.Ş.',
  shortName: 'Arpanet',
  address: 'ODTÜ Bilişim İnovasyon Merkezi — D Blok: 115/116/117',
  district: 'Çankaya, Ankara',
  country: 'Türkiye',
  email: 'info@arpanet.com.tr',
  /** Printed with the spacing a Turkish reader expects. */
  phone: '+90 (312) 486 00 22',
  /** The same number as a URL, which must be digits and a leading plus. A
   *  `tel:` with spaces and parentheses in it is a link some dialers refuse. */
  phoneHref: 'tel:+903124860022',
} as const

/** The address as one line, for structured data and for the places a postal
 *  address is read rather than laid out. */
export const COMPANY_ADDRESS_LINE = `${COMPANY.address}, ${COMPANY.district}, ${COMPANY.country}`

/**
 * The demo request, which is a `mailto:` and not a form.
 *
 * There is no backend here — the site is static files on nginx, deliberately
 * (ADR-0033) — so a form would need an endpoint, a spam story and somewhere for
 * the message to go when that endpoint is down. A `mailto:` with the subject
 * filled in reaches a human inbox that already exists, and it cannot fail
 * silently the way a POST to a dead handler does.
 */
export function demoMailto(subject: string): string {
  return `mailto:${COMPANY.email}?subject=${encodeURIComponent(subject)}`
}
